function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class ColumnOrder {
    constructor(order){
        _define_property(this, "key", void 0);
        _define_property(this, "viewId", void 0);
        _define_property(this, "columnOrder", void 0);
        _define_property(this, "orderType", void 0);
        _define_property(this, "createdAt", void 0);
        this.key = order.key;
        this.viewId = order.viewId;
        this.columnOrder = order.columnOrder;
        this.orderType = order.orderType;
        this.createdAt = order.createdAt;
    }
}
